import { useNavigate } from "react-router-dom";
import { useVeniceAccount } from "../hooks/useVeniceAccount";
import { formatVeniceCredits, veniceStatusLabel } from "../lib/venice";
import { Icon } from "./Icon";

export function VeniceCreditsBadge({ compact = false }: { compact?: boolean }) {
  const navigate = useNavigate();
  const { data, isLoading } = useVeniceAccount();
  const status = data ? veniceStatusLabel(data.status, data.connected) : "Unavailable";
  const credits = isLoading ? "…" : formatVeniceCredits(data?.balance.spendableCredits ?? null, compact);
  return (
    <button className={`venice-credits ${compact ? "venice-credits--compact" : ""} venice-credits--${data?.status ?? "unverified"}`} onClick={() => navigate("/app/profile?tab=venice")} title={`${credits} Venice Credits · ${status}`}>
      <span className="venice-credits__mark"><Icon name="spark" size={compact ? 15 : 17}/></span>
      {!compact && <span><strong>{credits} Credits</strong><small>Venice · {status}</small></span>}
      {compact && <strong>{credits}</strong>}
    </button>
  );
}
